import UpstartTaxLogo from '@/assets/branding/upstarttax/upstart-tax-academy-logo.png';

export default {
  name: 'Upstart Tax Academy',
  isSAML: true,
  allowPersonalCourses: false,
  logo: UpstartTaxLogo,
  colors: {
    // Brand colors
    brand_primary: '#FF8340',
    brand_primary_hover: '#F56517',
    brand_primary_highlight: '#FFCFB5',
    brand_primary_mid: '#FF9D69',
    brand_primary_dark: '#BD4403',
    brand_secondary: '#E36810',
  },
};
